<div class="alert-settings-filter-panel">
  <div class="filter-container">
    <div>
      <nz-radio-group
        [nzSize]="'small'"
        [ngModel]="alertType"
        (ngModelChange)="handleAlertTypeChange($event)"
        nzButtonStyle="solid"
      >
        <label nz-radio-button [nzValue]="alertTypeEnum.company">
          Company
        </label>
        <label nz-radio-button [nzValue]="alertTypeEnum.watchlist">
          Watchlist
        </label>
      </nz-radio-group>
    </div>

    <div>
      <nz-select
        *ngIf="alertType === alertTypeEnum.company"
        class="company-search"
        nzShowSearch
        nzServerSearch
        [nzSize]="'small'"
        nzPlaceHolder="Search Company Alerts"
        [(ngModel)]="selectedCompany"
        (nzOnSearch)="searchCompanyDebounced($event)"
        (ngModelChange)="onCompanySelect($event)"
        [nzNotFoundContent]="noCompanyMsg"
        [nzShowArrow]="false"
        [nzAllowClear]="true"
        [nzDropdownClassName]="
          !showDropdown ? 'search-result-hidden' : 'alerts-company-search'
        "
      >
        <nz-option-group [nzLabel]="companyOptions.name">
          <nz-option
            nzCustomContent
            *ngFor="let option of companyOptions.data"
            [nzLabel]="option.companyName"
            [nzValue]="option.ticker"
          >
            <span
              [innerHtml]="
                option.companyName + ' (' + option.ticker + ')'
                  | textHighlight: companyToSearch
              "
            ></span>
          </nz-option>
        </nz-option-group>
      </nz-select>

      <button
        *ngIf="alertType === alertTypeEnum.watchlist"
        [nzSize]="'small'"
        nz-button
        (click)="redirectWatchlist()"
        class="button ant-btn-primary-hollow"
      >
        Edit Watchlist
      </button>
      <button
        nz-button
        [nzSize]="'small'"
        (click)="deleteAlerts()"
        [disabled]="!deleteEnable"
        class="button ant-btn-primary-hollow"
      >
        <va-icon size="small" name="trash" class="fa-sm"></va-icon> Delete
      </button>
      <button
        nz-button
        [nzSize]="'small'"
        (click)="handleAlertsModal(true)"
        class="button ant-btn-primary-hollow"
      >
        <va-icon size="small" name="plus-circle" class="fa-sm"></va-icon> New
      </button>
    </div>
  </div>
  <ng-template #searchIcon>
    <i nz-icon nzType="search" nzTheme="outline"></i>
  </ng-template>

  <app-set-alert-modal
    [showAlertsModal]="showAlertsModal"
    [alertType]="alertType"
    (onCancel)="handleAlertsModal(false)"
    (onOk)="alertSet()"
  ></app-set-alert-modal>
</div>
